import { FC } from "react"
import {
	YMap,
	YMapDefaultSchemeLayer,
	YMapDefaultFeaturesLayer,
	YMapComponentsProvider,
	YMapMarker,
} from "ymap3-components"
import { COORDINATES, MAP_OPTIONS } from "@/features/ymap/const/location"
import { selectAddFilters } from "@/entities/options"
import { useAppSelector } from "@/shared/lib/store"

import MapMarker from "@/shared/assets/icons/marker-pin-03.svg?react"

interface MapProps {}

export const Map: FC<MapProps> = ({}) => {
	const addFilter = useAppSelector(selectAddFilters)

	if (!addFilter) return

	return (
		<YMapComponentsProvider apiKey={"74ffd07d-97cc-4462-87c0-05eae6462907"}>
			<YMap location={MAP_OPTIONS}>
				<YMapDefaultSchemeLayer />
				<YMapDefaultFeaturesLayer />
				<YMapMarker coordinates={COORDINATES}>
					<MapMarker width={64} height={64} />
				</YMapMarker>
			</YMap>
		</YMapComponentsProvider>
	)
}
